// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = "https://jltjuoxyeiptjkjbclre.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImpsdGp1b3h5ZWlwdGpramJjbHJlIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NTQ5ODUzMzEsImV4cCI6MjA3MDU2MTMzMX0.myF9i7xf4uZJ-9VLYvHUG6sBdY2eEv42Nq2P8hikcGc";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY, {
  auth: {
    storage: localStorage,
    persistSession: true,
    autoRefreshToken: true,
  }
});